import makeApiCall from "./master/axiosIndex";

export const uploadApis = {
  fetchBulkUploadReportById: (
    reportId: number,
    pageNo = 1,
    size = 10
  ): Promise<any> => {
    return makeApiCall({
      url: `/excel-upload/fetchReportById`,
      method: "get",
      params: {
        reportId: reportId,
        pageNo,
        size,
      },
    });
  },

  processExcelCreationById: (reportId: number): Promise<any> =>
    makeApiCall({
      url: `/excel-upload/processExcelCreationById`,
      method: "patch",
      params: { id: reportId },
    }),

  deleteExcelCreationById: (reportId: number): Promise<any> =>
    makeApiCall({
      url: `/excel-upload/deleteExcelCreationById`,
      method: "delete",
      params: { id: reportId },
    }),

  fetchProcurementReferences: (
    siteIds: string | number | (string | number)[],
    dependencies?: string | string[]
  ): Promise<any> =>
    makeApiCall({
      url: `/buyer/fetchProcurementRequestDependenciesBySiteIds`,
      method: "get",
      params: {
        siteIds: Array.isArray(siteIds) ? siteIds.join(",") : siteIds,
        ...(dependencies && {
          dependencies: Array.isArray(dependencies)
            ? dependencies.join(",")
            : dependencies,
        }),
      },
    }),

  //  bulk uploads
  uploadPurchaseRequestBulk: (file: File, body: any = {}): Promise<any> => {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("body", JSON.stringify(body));

    return makeApiCall({
      url: `/purchase-request/bulk-new`,
      method: "post",
      data: formData,
    });
  },

  uploadPurchaseOrderBulk: (file: File, body: any = {}): Promise<any> => {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("body", JSON.stringify(body));

    return makeApiCall({
      url: `/order-vs-billing/upload-bulk-orders`,
      method: "post",
      data: formData,
    });
  },

  uploadInvoiceBulk: (file: File, body: any = {}): Promise<any> => {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("body", JSON.stringify(body));

    return makeApiCall({
      url: `/billing/upload-bulk-invoices`,
      method: "post",
      data: formData,
    });
  },

  uploadPaymentBulk: (file: File, body: any = {}): Promise<any> => {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("body", JSON.stringify(body));

    return makeApiCall({
      url: `/payment/upload-bulk-payments`,
      method: "post",
      data: formData,
    });
  },
};
